import axios from './request'

/**
 * 通过榜单id搜索房屋
 * @param {Array} ids 榜单id集合
 */
// eslint-disable-next-line
export function fetchHouseIds({ ids }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/cms/getextenddata', arguments[0])
}
/**
 * 通过房屋id获取房屋详情
 * @param {Array} houseIdList 房屋id集合
 */
// eslint-disable-next-line
export function fetchHouseDetail({ houseIdList,noNeedPrice,needUnactive,needNoRepositoty }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/search/searchhousebyhouseidlist', arguments[0])
}

/**
 * 以下接口——收藏各功能全部下掉
 */
/**
 * 收藏榜单
 * @param {Array} activityId 榜单id集合
 */
// eslint-disable-next-line
export function favoriteTopList({ activityId }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/favorite/favoritecmstujia', arguments[0])
}
/**
 * 取消收藏榜单
 * @param {Array} activityId 榜单id集合
 */
// eslint-disable-next-line
export function unfavoriteTopList({ activityId }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/favorite/cancelfavoritecmstujia', arguments[0])
}
/**
 * 获取收藏和关注数
 * @param {Array} activityIdList 榜单id集合
 * @param {Number} favoriteItemType 5代表cms端
 * @param {Number} virtureType 是否返回真实收藏数（1:返回真实+系数，0:真实）
 */
// eslint-disable-next-line
export function getFavoriteAndFocus({ favoriteItemType,activityIdList,virtureType }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/favorite/searchfavoritepeoplenum', arguments[0])
}
/**
 * 获取收藏状态
 * @param {Array} activityIdList 榜单id集合
 */
// eslint-disable-next-line
export function checkFavorite({ activityIdList }) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/favorite/searchcmsfavoritestatus', arguments[0])
}

export function doFavorite(activityId, like) {
  let url = ''
  if (like) {
    url = '/feapi/bingo/h5/promotion/favorite/favoritecmstujia'
  } else {
    url = '/feapi/bingo/h5/promotion/favorite/cancelfavoritecmstujia'
  }
  return axios.post(url, {
    activityId
  })
}
